const initialState = () => ({
  step: 'category',
  category: null,
  subcategory: null,
  ticket: '',
})

// orderNum/message live in the dialog's own form data (bound with v-model), not here.
// This mixin only owns navigation/selection state that drives branching.
export default {
  data() {
    return {
      wizard: initialState(),
    }
  },
  computed: {
    wizardSteps() {
      if (!this.wizard.category) {
        return ['category']
      }
      if (this.wizard.category.infoOnly) {
        return ['category', 'training_info']
      }
      if (this.wizard.category.orderRedirect) {
        return ['category', 'order_num', 'ticket_form']
      }
      if (!this.wizard.category.subs.length) {
        return ['category', 'ticket_form', 'confirm']
      }
      return ['category', 'subcategory', 'ticket_form', 'confirm']
    },
    wizardStepIdx() {
      const currentStep = this.wizard.step
      if (currentStep === 'category') {
        return 0
      }
      if (currentStep === 'training_info') {
        return 1
      }
      if (currentStep === 'subcategory') {
        return 1
      }
      if (currentStep === 'order_num') {
        return this.wizard.category && this.wizard.category.orderRedirect
          ? 1
          : 2
      }
      if (currentStep === 'order_redirect') {
        return 2
      }
      if (currentStep === 'ticket_form') {
        return this.wizardSteps.length - 2
      }
      if (currentStep === 'confirm') {
        return this.wizardSteps.length - 1
      }
      return 0
    },
    isWizardEndStep() {
      return ['confirm', 'training_info', 'order_redirect'].includes(
        this.wizard.step,
      )
    },
  },
  methods: {
    resetWizard() {
      this.wizard = initialState()
    },
    selectWizardCategory(category) {
      this.wizard.category = category
      this.wizard.subcategory = null
    },
    selectWizardSubcategory(subcategory) {
      this.wizard.subcategory = subcategory
    },
    // orderNum/message come from the dialog's form data at the call site,
    // since this mixin no longer tracks form-field values itself.
    wizardCanNext({ orderNum = '', message = '' } = {}) {
      const currentStep = this.wizard.step
      if (currentStep === 'category') {
        return !!this.wizard.category
      }
      if (currentStep === 'subcategory') {
        return !!this.wizard.subcategory
      }
      if (currentStep === 'order_num') {
        return orderNum.trim().length > 0
      }
      if (currentStep === 'ticket_form') {
        return message.trim().length > 0
      }
      return true
    },
    advanceWizard() {
      let step = this.wizard.step
      if (step === 'category') {
        if (this.wizard.category.infoOnly) {
          step = 'training_info'
        } else if (this.wizard.category.orderRedirect) {
          step = 'order_num'
        } else if (!this.wizard.category.subs.length) {
          step = 'ticket_form'
        } else {
          step = 'subcategory'
        }
      } else if (step === 'subcategory') {
        step = 'ticket_form'
      } else if (step === 'order_num') {
        step = 'order_redirect'
      }
      this.wizard.step = step
    },
    goBackWizard() {
      let step = this.wizard.step
      let subcategory = this.wizard.subcategory
      if (step === 'subcategory') {
        step = 'category'
        subcategory = null
      } else if (step === 'order_num') {
        step = 'category'
      } else if (step === 'ticket_form') {
        step = this.wizard.category.subs.length ? 'subcategory' : 'category'
      } else if (step === 'training_info') {
        step = 'category'
      } else if (step === 'order_redirect') {
        step = 'order_num'
      }
      this.wizard.step = step
      this.wizard.subcategory = subcategory
    },
    completeWizardTicket(ticket) {
      this.wizard.ticket = ticket
      this.wizard.step = 'confirm'
    },
  },
}
